import './Header.css';
import { loginRequest } from "./../../authConfig";
import Button from '@mui/material/Button';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

export default function Header() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest)
      .catch((error) => console.log(error));
  }

  const handleLogout = () => {
    instance.logoutRedirect({postLogoutRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI!});
  }

  return (
    <div className="header" role="banner">
      <span>Notification Content Manager</span>
      <AuthenticatedTemplate>
        <Button type="button" variant="contained" className="button" onClick={handleLogout}>Sign out</Button>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button type="button" variant="contained" className="button" onClick={handleLogin}>Sign in</Button>
      </UnauthenticatedTemplate>
    </div>
  );
}